<!-- class_state 0--正常 1--没在库里 2--进价低 3--进价高 -->
<template>
  <div class="fa">
    <!-- 顶部按钮部分 -->
    <div class="dyh-line-group">
      <div class="top-btn-danju">
        <dyh-goods-search ref="dyhgoodssearchRef" @getGoods="getGoods" @dyhGoodsSearchReturn="dyhGoodsSearchReturn"
          :who="'insheet'"></dyh-goods-search>
      </div>
      <div style="width:auto;min-width:600px;text-align:right;">
        <el-button size="mini" :disabled="sheet_no == '' || sheet_no.length == 0 || sheet_approve == '1'
          " @click="deleteSheet" type="danger">删除单据</el-button>
        <!-- <el-button size="mini" type="success" @click="printTabledata"
          >输出tabledata</el-button
        > -->
        <el-button size="mini" type="success" @click="newSheet(false)">新建单据</el-button>
        <el-button size="mini" @click="sheetList" type="warning">选择单据</el-button>
        <!-- <el-button :disabled="modify_list.length<=0&&sheet_approve" size="mini" @click="saveSheetModify" type="primary"
          >保存单据修改</el-button> -->
        <el-button :disabled="sheet_approve == '1'" size="mini" @click="saveAndUpload" type="primary">保存单据</el-button>
        <el-button :disabled="sheet_no == '' || sheet_no.length == 0 || sheet_approve == '0'
          " size="mini" @click="sheetUnApprove" type="primary">单据反审核</el-button>
        <el-button :disabled="sheet_no == '' || sheet_no.length == 0 || sheet_approve == '1'
          " size="mini" @click="sheetApprove" type="danger">审核单据</el-button>
      </div>
    </div>

    <div id="in-sheet" style="" ref="contextmenuTargetRef" class="dyh-body-group">
      <div class="danju-sheetno">
        <!-- <div v-if="sheet_no">单号：{{ sheet_no }}</div>  -->
        <!-- :class="sheetwho == 'insheet' ? 'danju-insheet' : 'danju-outsheet'" -->

        <img v-if="sheet_no && sheet_approve == '0'" class="watermark" src="@/assets/pic/audit.png" />
        <img v-if="sheet_no && sheet_approve == '1'" class="watermark" src="@/assets/pic/Reviewed.png" />
        <!-- <div class="danju-basic">
          {{ tbheader }}
          <p style="width:20px"></p>
          {{ sheet_no }}
        </div> -->
        <!-- sheetwho == "insheet" ? "入库单" : "销售单" -->
      </div>
      <!-- 表头部信息 -->
      <div class="documents_head" v-if="false">

        <el-form :model="header_info" label-width="80px" style="margin-bottom:5px;">
          <el-row class="el-row-1">
            <el-col :span="8">
              <span v-if="sheetwho == 'outsheet'">
                <p class="p-label">店铺：</p>
                {{ merchant_name }}
              </span>
              <span class="span-inline" v-else>
                <p class="p-label">对方店铺：</p>
                <wty-select id="1" :disabled="sheet_approve == '1'" :width="300" :size="'mini'" :who="'merchant'"
                  ref="sellerwtySelectRef" @getReturn="wtySelectGetReturn"></wty-select>
              </span>
            </el-col>
            <el-col :span="8">
              <span v-if="sheetwho == 'insheet'">
                <p class="p-label">店铺：</p>
                {{ merchant_name }}
              </span>
              <span class="span-inline" v-else>
                <p class="p-label">对方店铺：</p>
                <wty-select id="1" :width="150" :size="'mini'" :who="'merchant'" ref="wtySelectRef"
                  :disabled="sheet_approve == '1'" @getReturn="wtySelectGetReturn"></wty-select>
              </span>
            </el-col>
            <el-col :span="8" v-if="sheetwho == 'insheet'">
              <span>
                <p class="p-label">仓库号：</p>
                <wty-select id="1" :width="150" :size="'mini'" :who="'branch'" ref="wtyBranchSelectRef"
                  :disabled="sheet_approve == '1'" @getReturn="wtySelectGetReturn"></wty-select>

                <!-- <el-input
                  size="mini"
                  style="width: 150px;"
                  v-model="header_info.branch_no"
                  placeholder=""
                ></el-input> -->
              </span>
            </el-col>
            <el-col :span="6" v-else>
              <p class="p-label">仓库号：</p>
              <el-input size="mini" style="width: 150px;" :disabled="sheet_approve == '1'"
                v-model="header_info.branch_no" placeholder=""></el-input>
            </el-col>
            <!-- <el-col :span="1.5"> 单据类型： </el-col>
            <el-col :span="4.5">
              <input
                class="biaotou-remark"
                v-model="header_info.other1"
                type="text"
              />
            </el-col> -->
          </el-row>
          <el-row class="el-row-2">
            <el-col :span="8">
              <p class="p-label">合计数量：</p>
              {{ header_info.total_qty }}
            </el-col>
            <el-col :span="8">
              <p class="p-label">合计金额：</p>
              {{ header_info.total_amount }}
              <i v-if="header_info.total_amount" style="margin-left:10px">元</i>
            </el-col>
            <!-- <el-col :span="5">
              付款金额：<el-input
                size="mini"
                style="width:150px"
                v-model="header_info.pay_amount"
                placeholder=""
              ></el-input>
            </el-col> -->
            <!-- <el-col :span="6">
              折扣金额：
              <el-input
                size="mini"
                style="width:150px"
                v-model="header_info.discount_amount"
                placeholder=""
              ></el-input>
            </el-col> -->
            <el-col :span="8">
              <p class="p-label">结账日期：</p>

              <el-date-picker size="mini" style="width: 150px " v-model="header_info.settlement_date"
                :disabled="sheet_approve == '1'" type="date" placeholder="选择结账日期">
              </el-date-picker>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 表格部分(商品信息) -->
      <div style="padding-top: 10px;">
        <ve-contextmenu :eventTarget="eventTarget" :options="rmOptions"
          @on-node-click="contextmenuClick"></ve-contextmenu>
        <ve-table id="loading-container" v-if="maintableShow" border-x border-y ref="maintableRef"
          :sort-option="sortOption" :columns="sheetcolumns" :scroll-width="1500" :border-around="true"
          :fixed-header="true" :table-data="tableData" :editOption="editOption" rowKeyFieldName="rowKey"
          :rowStyleOption="rowStyleOption" :cell-style-option="cellStyleOption" :event-custom-option="eventCustomOption"
          :cellSelectionOption="cellSelectionOption" :virtual-scroll-option="virtualScrollOption"
          :checkbox-option="checkboxOption" :footer-data="footData" :fixed-footer="true" enable="true" />
        <!--           :maxHeight="`${mainH - 15}px`" -->
        <!-- <div class="tableEmpty" v-show="tableEmpty">
          style="`min-height:${mainH}px`"
          暂无数据</div> -->
      </div>
    </div>
    <div style="width: 100%;height: 10px;"></div>
    <!-- 模态框部分 -->
    <selectEdit ref="selectEditRef" :sheetwho="sheetwho" @bindDetermine="bindDetermine"
      @formatSalePrice="formatSalePrice"></selectEdit>
    <excel ref="excel" :covershow="sheet_no == '' ? true : false" @FileName="FileName" @update-import="updateTableData"
      @cover-import="CoverTableData">更新并导入</excel>
    <wty-select-box ref="wtySelectBoxRef" :who="'goodsinfo'" @getReturn="getReturn"></wty-select-box>
    <wty-select-box ref="wtyRadioSelectBoxRef" :who="'goodsinfoRadio'" @getReturn="getRadioReturn"></wty-select-box>
    <wty-select-box ref="wtySheetSelectBoxRef" :who="'sheetinfo'" @getReturn="getSheetReturn"></wty-select-box>
    <dyh-auditsheet ref="dyhauditsheetRef" @dyhauditsheetReturn="dyhauditsheetReturn"></dyh-auditsheet>
  </div>
</template>
<script>
import dyhGoodsSearch from "@/components/dyh-goodsSearch.vue";
import {
  exportExcel
} from "@/js/exportExcel.js";
import wtySelectBox from "@/components/wty-selectBox.vue";
import wtySelect from "@/components/wty-select.vue";
import selectEdit from "@/components/selectEdit.vue";
import dyhAuditsheet from "./dyh-auditsheet.vue";
import excel from "@/components/excel.vue";
import { cellStyleOption } from "@/js/sheettablecolumn";
import {
  sheetGenerate,
  getBasegoodsInfo,
  basegoodsBatchquery,
  getSheetList,
  sheetQuery,
  sheetModify,
  sheetDelete,
  sheetApprove,
  sheetUnApprove,
  sheetLastTranscationPrice
} from "@/api/goodsinfo";
/* import { deleteTabRepeat } from "@/js/public.js";
import { testR } from "@/api/common"; */
import { myFixed } from "@/js/public";
import {
  offlineSearchGoodsInfo,
  offlineGoodsBatchQuery,
  offlineQueryStock
} from "@/api/offlinestores.js";
export default {
  name: "sheet",
  components: {
    excel,
    selectEdit,
    wtySelectBox,
    "wty-select": wtySelect,
    dyhAuditsheet,
    dyhGoodsSearch
  },
  props: ["sheetwho", "tbheader", "sheetcolumns", "sheettype", "branchflag"],
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.mainH = newinner.innerHeight - 280;
        } else {
          this.mainH = newinner.innerHeight - 300;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    availWH() {
      return this.$store.state.resolution.availWH;
    },
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  data() {
    return {
      morelist: [], //重复条码的数组
      merchant_name: localStorage.getItem("merchant_name"),
      sheet_approve: "0", //单据状态
      modify_list: [], //商品修改列表
      sheet_no: "",
      file_name: "",
      allGoods_list: [],
      eventTarget: "", //右键菜单
      //右键菜单option
      rmOptions: [
        {
          label: "导入excel",
          disabled: false,
          type: "daoRu"
        },
        {
          label: "导出",
          disabled: false,
          type: "exportXML"
        },
        {
          type: "SEPARATOR"
        },
        {
          label: "新增一行",
          disabled: false,
          type: "addGoods"
        },
        {
          label: "删除选中行",
          disabled: false,
          type: "deleteGoods"
        },
        {
          type: "SEPARATOR"
        },
        {
          label: "批量修改选中商品",
          disabled: false,
          type: "DialogVisible"
        },
        {
          label: this.sheetwho === "insheet" ? "计算售价" : "计算建议售价",
          disabled: false,
          type: "bulkModify"
        }
      ],
      //搜索框数据
      search_value: "",
      // 主表高度
      mainH: 0,
      maintableShow: true,
      //空数据
      tableEmpty: false,
      row_data: {},
      footData: [],
      // 商品列表、单据列表
      goods_show: false,
      title_show: true,
      checkedGoods: [], //选中商品列表
      sortOption: {
        sortChange: params => {
          this.sortChange(params);
        }
      },
      // 单据表头信息
      header_info: {
        sheet_type: this.sheettype,
        branch_no: "",
        total_amount: "",
        total_qty: "",
        branch_flag: this.branchflag, //仓库标识
        other_mch_no: "",
        seller_no: "",
        buyer_no: "",
        settlement_date: ""
        // total_sup_qty: "",
        // total_buyer_qty: "",
      },
      delete_Goods: [],
      // goods_data: [],
      //选中的商品信息
      goods_list: [],
      // 表格信息
      // 自定义的单机事件
      eventCustomOption: {
        bodyCellEvents: ({ row, column, rowIndex }) => {
          return {
            click: event => {
              this.delete_Goods = [];
              this.delete_Goods.push(row.barcode);
            }
          };
        }
      },
      //点击高亮显示
      rowStyleOption: {
        clickHighlight: false
      },
      //虚拟滚动
      virtualScrollOption: {
        // 是否开启
        enable: true
      },
      //是否开启单元格选择
      cellSelectionOption: {
        // disble cell selection
        enable: true
      },
      // edit option 修改后触发的事件
      editOption: {
        beforeStartCellEditing: ({ row, column, cellValue }) => {
          if (this.sheet_no && this.sheet_approve === "1") {
            this.warnMessage(
              "已经审核的单据不允许修改！如需修改请先进行反审核操作。"
            );
            return false;
          }
        },
        /* beforeCellValueChange: ({ row, column,cellValue}) => {
          if (this.sheet_no && this.sheet_approve == "1") {
            this.warnMessage(
              "已经审核的单据不允许修改！如需修改请先进行反审核操作。"
            );
            return false
          }
        }, */
        // cell value change
        /**
         * 单元格的值改变
         * @param {Object} row 行商品信息
         * @param {Object} column 行表格信息
         */
        afterCellValueChange: async ({ row, column }) => {
          this.row_data = row;
          //TODO:一会回来
          if (column.key === "money") {
            this.zero(this.tableData);
            this.computeInPrice();
            this.getSum();
          } else if (
            column.key === "in_price" ||
            column.key === "sale_price" ||
            column.key === "qty" ||
            column.key === "buyer_sale_price"
          ) {
            this.zero(this.tableData);
            this.compute();
            this.getSum();
            if (column.key === "in_price" || column.key === "sale_price") {
              this.$refs.maintableRef.setCellSelection({
                rowKey: row.rowKey - 1,
                colKey: "qty"
              });
            }
            if (column.key === "qty") {
              if (Number(row.rowKey) === this.tableData.length) {
                this.addGoods();
              }
              this.$refs.maintableRef.setCellSelection({
                rowKey: row.rowKey,
                colKey: "qty"
              });
            } /*  else {
              this.$refs["maintableRef"].setCellSelection({
                rowKey: row.rowKey,
                colKey: "qty"
              });
            } */
          } else if (column.key === "barcode") {
            /* if (row.barcode.length < 5) {
              this.warnMessage("模糊查询请输入更具体一些，否则会造成卡顿");
              return;
            } */
            this.loadingInstance.show();
            var res = {};
            if (this.sheetwho === "insheet") {
              res = await offlineSearchGoodsInfo(
                row.barcode,
                false,
                this.header_info.branch_no
              );
            } else if (this.sheetwho === "outsheet") {
              res = await getBasegoodsInfo(row.barcode, false);
            }
            if (this.testR(res)) {
              if (res.data.resp_data && res.data.resp_data.length === 0) {
                if (this.sheetwho === "insheet") {
                  //TODO: 搜索线上库
                  const res = await basegoodsBatchquery([row.barcode]);
                  if (
                    this.testR(res) &&
                    res.data.resp_data[0].query_state === "SUCCESS"
                  ) {
                    if (res.data.resp_data) {
                      row.class_state = "6";
                      row.item_name = res.data.resp_data[0].item_name;
                      row.item_no = "";
                      row.class_no = "";
                      row.advise_price = res.data.resp_data[0].advise_price;
                    }
                  } else {
                    // 没有该商品应该 爆红
                    row.class_state = "6";
                    row.item_name = "";
                    row.item_no = "";
                    row.class_no = "";
                    row.advise_price = "";
                    row.flow_no = row.rowKey;
                    this.warnMessage("未搜索到该商品。");
                  }
                }
              } else if (res.data.resp_data && res.data.resp_data.length === 1) {
                row.class_state = "0";
                row.item_name = res.data.resp_data[0].item_name;
                row.item_no = res.data.resp_data[0].item_no
                  ? res.data.resp_data[0].item_no
                  : "";
                row.barcode = res.data.resp_data[0].barcode;
                row.class_no = res.data.resp_data[0].class_no;
                row.in_price = res.data.resp_data[0].in_price;
                row.advise_price = res.data.resp_data[0].advise_price;
                const number = await offlineQueryStock(
                  row.barcode,
                  row.sup_no,
                  this.header_info.branch_no ? this.header_info.branch_no : "00"
                );
                //把stock设置成双向绑定属性
                this.$set(row, "stock", number || "0.00");
                if (this.sheetwho === "outsheet") {
                  //设置选中
                  this.$refs.maintableRef.setCellSelection({
                    rowKey: row.rowKey,
                    colKey: "sale_price"
                  });
                } else if (this.sheetwho === "insheet") {
                  this.$refs.maintableRef.setCellSelection({
                    rowKey: row.rowKey,
                    colKey: "in_price"
                  });
                }
              } else if (res.data.resp_data && res.data.resp_data.length > 1) {
                this.$refs.wtySelectBoxRef.showDialog(res.data.resp_data);
              }
              //
            }
            this.loadingInstance.close();

            /* mdata.item_name = res.data.resp_data[0].item_name;
            mdata.class_no = res.data.resp_data[0].class_no; */
          }
          if (this.sheet_no) {
            this.modify_list.push(row.rowKey);
          }
        }
      },
      // 主体表格的表头
      // columns: [],
      // 出库单选择的商品信息
      tableData: [],
      // 返回复选框的选定状态(只是在选择商品使用)
      checkboxOption: {
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          // row选中行的数据 isSelected 选中的情况(true,false)
          if (isSelected === true) {
            this.checkedGoods.push(row.rowKey);
          }
          if (isSelected === false) {
            for (var i = 0; i < this.checkedGoods.length; i++) {
              if (this.checkedGoods[i] === row.rowKey) {
                this.checkedGoods.splice(i, 1);
              }
            }
          }
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          if (isSelected === true) {
            this.checkedGoods = [];
            for (var i = 0; i < this.tableData.length; i++) {
              this.checkedGoods[i] = this.tableData[i].rowKey;
            }
          } else {
            this.checkedGoods = [];
          }
        }
      },
      // radio单选
      radioOption: {
        // 行选择改变事件
        selectedRowChange: ({ row }) => { }
      },
      //单元格样式
      cellStyleOption: cellStyleOption
    };
  },
  created() {
    this.initFooterData();
    // alert(this.$route.params.merchment_id)
    // 获取从vendor页面传递过来的值
    // this.header_info.vendor = this.$route.params.merchant_name;
    //进货单和出库单的表头不一样

    //TODO:1
    /* if (this.sheetwho == "insheet") {
      this.header_info.buyer_no = localStorage.getItem("merchant_id");
    } else {
      this.header_info.seller_no = localStorage.getItem("merchant_id");
    } */

    this.vendor = localStorage.getItem("");
    this.computeReady(this.tableData);
    // this.getSum();
  },
  //可以删
  mounted() {
    const that = this;
    this.loadingInstance = this.$veLoading({
      target: "#in-sheet",
      // 等同于
      // target:"#loading-container"
      overlayBackgroundColor: "rgba(255,255,255,.5)",
      name: "grid"
    });
    this.eventTarget = this.$refs.contextmenuTargetRef;

    setTimeout(() => {
      that.addGoods();
    }, 100);
  },
  destroyed() {
    this.loadingInstance.destroy();
  },
  methods: {
    /**
     * 调用 dyh-goods-search 的 组件方法
     */
    getGoods() {
      this.$refs.dyhgoodssearchRef.search(this.allGoods_list);
    },
    /**
     * 获取 dyh-goods-search 的 组件返回方法
     */
    dyhGoodsSearchReturn(list) {
      this.tableData = list;
    },
    /**
     * 排序
     * @param {*} params
     */
    sortChange(params) {
      this.tableData.sort((a, b) => {
        if (params.item_name) {
          if (params.item_name === "asc") {
            return a.item_name.localeCompare(b.item_name, "zh");
          } else if (params.item_name === "desc") {
            return b.item_name.localeCompare(a.item_name, "zh");
          } else {
            return a.rowKey - b.rowKey;
          }
        } else if (params.barcode) {
          if (params.barcode === "asc") {
            return a.barcode - b.barcode;
          } else if (params.barcode === "desc") {
            return b.barcode - a.barcode;
          } else {
            return a.rowKey - b.rowKey;
          }
        } else {
          return a.rowKey - b.rowKey;
        }
      });
    },
    //测试输出表格数据
    printTabledata() {
      // console.log(this.tableData);
    },
    /**
     * dyh-auditsheet组件回调触发函数：
     *
     */
    dyhauditsheetReturn(res) {
      this.sheet_approve = "1";
    },
    /**
     * 单据反审核
     */
    async sheetUnApprove() {
      const unapprove = await sheetUnApprove(this.sheet_no);
      if (
        this.testR(unapprove) &&
        unapprove.data.resp_data.state === "SUCCESS"
      ) {
        this.successMessage(unapprove.data.resp_data.message);
        this.sheet_approve = "0";
      }
    },
    /**
     * 审核单据
     */
    async sheetApprove() {
      this.$refs.dyhauditsheetRef.showDialog(
        this.tableData,
        this.header_info.other_mch_no,
        this.sheetwho,
        this.header_info.branch_no,
        this.sheet_no
      );
      return;
      /* eslint-disable */
      const res = await sheetApprove(this.sheet_no);
      console.log("单据审核返回值：", res);
      if (this.testR(res)) {
        if (res.data.resp_data.state == "SUCCESS") { this.successMessage(res.data.resp_data.message); }
        this.sheet_approve = true;
      }
    },
    /**
     * 删除单据
     */
    deleteSheet() {
      this.$confirm("点击确定将会删除此单据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await sheetDelete(this.sheet_no);
          if (this.testR(res) && res.data.resp_data.state === "SUCCESS") {
            this.successMessage(res.data.resp_data.msg);
            this.newSheet(true);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "操作已取消"
          });
        });
    },
    /**
     * 新建单据
     * @param {*} message
     */
    newSheet(message = false) {
      if (message || (this.tableData.length === 0 && this.sheet_no === "")) {
        this.tableData = [];
        this.sheet_no = "";
        this.modify_list = [];
        this.getSum();

        if (!message) {
          this.$message({
            type: "success",
            message: "创建单据成功！"
          });
        }
        return;
      }
      this.$confirm("此操作将会清空单据内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.tableData = [];
          this.sheet_no = "";
          this.modify_list = [];
          this.getSum();
          setTimeout(() => {
            this.addGoods();
          }, 100);
          this.$message({
            type: "success",
            message: "创建单据成功！"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "操作已取消"
          });
        });
    },
    //提交单据
    /**
     * 提交单据
     */
    async saveAndUpload() {
      this.loadingInstance.show();
      if (this.sheet_no) {
        this.saveSheetModify();
        return;
      }
      if (
        this.header_info.settlement_date === "" ||
        this.header_info.settlement_date.length === 0
      ) {
        var dateTime = new Date();
        dateTime = dateTime.setMonth(dateTime.getMonth() + 1);
        this.header_info.settlement_date = new Date(dateTime);
      }
      var list = [];
      if (this.sheetwho === "outsheet") {
        for (let i = 0; i < this.tableData.length; i++) {
          list.push({
            barcode: this.tableData[i].barcode,
            flow_no: this.tableData[i].rowKey,
            qty: this.tableData[i].qty,
            price: this.tableData[i].sale_price,
            amount: this.tableData[i].money,
            batch_no: "",
            production_day: this.tableData[i].production_day
          });
        }
      } else if (this.sheetwho === "insheet") {
        // console.log(this.tableData);
        for (let i = 0; i < this.tableData.length; i++) {
          list.push({
            barcode: this.tableData[i].barcode,
            flow_no: this.tableData[i].rowKey,
            qty: this.tableData[i].qty,
            price: this.tableData[i].in_price,
            advise_price: this.tableData[i].advise_price,
            amount: this.tableData[i].money,
            class_no: this.tableData[i].class_no,
            batch_no: "",
            production_day: this.tableData[i].production_day
          });
        }
      }

      const res = await sheetGenerate(
        this.header_info,
        list,
        this.sheetwho === "insheet" ? "PI" : "SO",
        this.sheetwho === "insheet" ? "+" : "-"
      );
      if (this.testR(res)) {
        this.successMessage("单据创建成功！");
        this.sheet_no = res.data.resp_data.sheet_no;
      }

      this.loadingInstance.close();
    },
    //TODO:  保存单据修改
    async saveSheetModify() {
      //var that = this;
      var modify_list = [];
      for (let i = 0; i < this.tableData.length; i++) {
        modify_list.push(this.tableData[i]);
      }
      /* modify_list = this.tableData.filter(item => {
        return (
          that.modify_list.indexOf(item.rowKey) > -1 &&
          modify_list.indexOf(item.rowKey) == -1
        );
      }); */
      //TODO:----------------------
      let list = [];
      for (let i = 0; i < modify_list.length; i++) {
        /* if (
          this.sheetwho == "insheet" &&
          !modify_list[i].class_no &&
          modify_list[i].class_no == ""
        ) {
          this.warnMessage("类别不允许有空值！");
          return;
        } */

        var data = {
          barcode: modify_list[i].barcode,
          flow_no: modify_list[i].rowKey,
          qty: modify_list[i].qty ? modify_list[i].qty : "",
          price: "",
          class_no: modify_list[i].class_no,
          modify_flag: modify_list[i].modify_flag
            ? modify_list[i].modify_flag
            : "modify",
          advise_price: modify_list[i].advise_price
            ? modify_list[i].advise_price
            : 0,
          amount: modify_list[i].money ? modify_list[i].money : 0
        };

        if (this.sheetwho === "insheet") {
          data.price = modify_list[i].in_price;
        } else if (this.sheetwho === "outsheet") {
          data.price = modify_list[i].sale_price;
        }
        list.push(data);
      }
      const res = await sheetModify(this.header_info, list, this.sheet_no);
      if (this.testR(res) && res.data.resp_data.state === "SUCCESS") {
        this.successMessage("单据修改成功!");
      }
      this.loadingInstance.close();
    },
    /**
     * 搜索所有单据
     */
    async sheetList() {
      //PI 进货入库单 RO 退货出库单 SO 销售单
      if (this.sheetwho === "insheet") {
        const insheetres = await getSheetList("PI");
        let list = [];
        for (let i = 0; i < insheetres.length; i++) {
          list.push({
            ...insheetres[i]
          });
        }
        this.$refs.wtySheetSelectBoxRef.showDialog(list);
      }
      if (this.sheetwho === "outsheet") {
        const outsheetres = await getSheetList("SO");
        let list = [];
        for (let i = 0; i < outsheetres.length; i++) {
          list.push({
            ...outsheetres[i]
          });
        }
        this.$refs.wtySheetSelectBoxRef.showDialog(list);
      }
    },
    //wtyselect return 仓库选择
    wtySelectGetReturn(res) {
      /* if (this.sheetwho == "insheet") {
        this.header_info.other_mch_no = res.value;
      } else if (this.sheetwho == "outsheet") {

      } */
      if (res.who === "merchant") {
        this.header_info.other_mch_no = res.value;
      } else if (res.who === "branch") {
        this.header_info.branch_no = res.value;
      }
    },
    /**
     * 上传文件名称用于下载文件时输入文件名
     * @param {*} file_name
     */
    FileName(file_name) {
      this.file_name = file_name;
    },
    //模糊查找商品
    searchGoods() {
      this.loadingInstance.show();
      if (this.allGoods_list == []) {
        this.loadingInstance.close();
        return;
      }
      var that = this;
      // search_value;
      if (this.search_value === "" || this.search_value.length === 0) {
        this.tableData = [];
        this.tableData = this.allGoods_list;
        this.loadingInstance.close();
        return;
      } else {
        let list = this.allGoods_list.filter((item, index) => {
          return (
            String(item.item_name).indexOf(that.search_value) >= 0 ||
            String(item.barcode).indexOf(that.search_value) >= 0
          );
        });
        this.tableData = [];
        this.tableData = list;
      }
      this.loadingInstance.close();
    },
    //wtyselectbox 商品信息 return
    /**
     * 获取所有商品
     */
    getReturn(res) {
      /* console.log("res------",res);
      if (res.length == 1) {
        console.log("就一个商品")
        this.row_data.barcode = res.barcode;
        this.row_data.item_name = res.item_name;
        // this.row_data.item_size = res.item_size;
        this.row_data.advise_price = res.advise_price;
        this.row_data.class_no = res.class_no;
        this.row_data.class_state = "0";
        this.$refs["maintableRef"].setCellSelection({
          rowKey: this.row_data.rowKey,
          colKey: "qty"
        });
      } else {} */

      //s删除选中的那一行
      if (this.sheet_no.length > 0 && res.length > 1) {
        this.warnMessage("修改单据不支持导入多个商品");
        return;
      }

      this.checkedGoods.push(this.row_data.rowKey);
      this.deleteGoods(true);
      //更新并导入所有数据
      this.updateTableData(res);
    },
    // 选择单据列表返回
    async getSheetReturn(res) {
      console.log("选择单据", res);

      //TODO: 单据状态 审核、未审核
      this.sheet_approve = res.approve_flag;
      this.sheet_no = res.sheet_no;
      const result = await sheetQuery(res.sheet_no);
      if (this.testR(result)) {
        for (let key in result.data.resp_data) {
          if (key === "detail") {
            break;
          }
          this.header_info[key] = result.data.resp_data[key];
        }
        // console.log("单据返回：",result.data.resp_data);

        this.tableData = [];
        // this.insertData();
        const list = result.data.resp_data.detail;
        var array = [];
        if (this.sheetwho === "insheet") {
          //入库单
          for (let i = 0; i < list.length; i++) {
            array.push({
              barcode: list[i].barcode,
              production_day: list[i].production_day, //生产日期
              //sup_price: list[i].sale_price,
              sale_price: list[i].sale_price, //insert函数需要的属性名
              buyer_sale_price: list[i].sale_price, //购买方的售价
              in_price: list[i].price, //进价
              qty: list[i].qty,
              flow_no: list[i].flow_no,
              profit: 0,
              modify_flag: "insert",
              amount: list[i].amount
            });
          }
          // console.log("resresres-=-=-=-=-=-=", res);
          //入库单绑定销售方店铺
          this.$refs.sellerwtySelectRef.setSelect(res.other_mch_no);
          this.$refs.wtyBranchSelectRef.setSelect(this.header_info.branch_no);
          // this.$refs.wtySelectRef.setSelect(res.other_mch_no);
        } else if (this.sheetwho === "outsheet") {
          for (let i = 0; i < list.length; i++) {
            // 这里是选择出库单之后
            array.push({
              barcode: list[i].barcode,
              production_day: list[i].production_day,
              /* sup_price: list[i].sale_price,
              buyer_qty: list[i].buyer_qty,
              buyer_price: list[i].sale_price,
              sup_qty: list[i].sale_qty,
              buyer_sale_price: list[i].buyer_sale_price,*/
              sale_price: list[i].price,
              qty: list[i].qty,
              amount: list[i].amount,
              flow_no: list[i].flow_no,
              modify_flag: "insert"
            });
          }
          //出库单绑定购买方方店铺
          this.$refs.wtySelectRef.setSelect(res.other_mch_no);
        }
        this.insertData(array);
      }
      this.getSum();
      // this.computeInPrice();
      // this.computeReady();
    },
    //格式化售价时模态框显示
    checkModify(key) {
      this.$refs.selectEditRef.changeModal(key, true);
    },
    // 选中批量修改
    bindDetermine({ key, value }) {
      // for (var i = 0; i < this.checkedGoods.length; i++) {}
      for (var j = 0; j < this.tableData.length; j++) {
        if (this.checkedGoods.indexOf(this.tableData[j].rowKey) > -1) {
          this.tableData[j][key] = value;
          if (this.sheet_no) {
            this.modify_list.push(this.tableData[j].rowKey);
          }
        }
      }
    },
    //计算售价
    formatSalePrice(formatsp_data) {
      this.loadingInstance.show();
      const array = [];
      //小数部分数字
      for (let t = 0; t < formatsp_data.change_to.length; t++) {
        if (
          formatsp_data.change_to[t] !== "" ||
          formatsp_data.change_to[t].length !== 0
        ) {
          array.push(formatsp_data.change_to[t]);
        }
      }
      if (this.sheetwho === "outsheet") {
        for (let i = 0; i < this.tableData.length; i++) {
          let advise_price = (
            Number(this.tableData[i].sale_price) /
            (1 - Number(formatsp_data.point) / 100)
          ).toFixed(1);
          let afterdot = String(advise_price).substring(
            advise_price.indexOf(".") + 1
          );
          let beforedot = String(advise_price).slice(
            0,
            advise_price.indexOf(".") + 1
          );
          if (array.length !== 0) {
            if (!array.includes(afterdot)) {
              let y = 0;
              let temp = Math.abs(afterdot - array[0]);
              for (let x = 0; x < array.length; x++) {
                if (Math.abs(afterdot - array[x]) < temp) {
                  temp = Math.abs(afterdot - array[x]);
                  y = x;
                }
              }
              afterdot = array[y];
            }
          }
          this.tableData[i].advise_price = beforedot + afterdot;
        }
      } else if (this.sheetwho === "insheet") {
        if (formatsp_data.amount) {
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].buyer_sale_price = this.tableData[i].in_price;
          }
          this.computeReady(this.tableData);
          this.loadingInstance.close();
          return;
        }
        for (let i = 0; i < this.tableData.length; i++) {
          let buyer_sale_price = (
            Number(this.tableData[i].in_price) /
            (1 - Number(formatsp_data.point) / 100)
          ).toFixed(1);
          let afterdot = String(buyer_sale_price).substring(
            buyer_sale_price.indexOf(".") + 1
          );
          let beforedot = String(buyer_sale_price).slice(
            0,
            buyer_sale_price.indexOf(".") + 1
          );
          if (array.length !== 0) {
            if (!array.includes(afterdot)) {
              let y = 0;
              let temp = Math.abs(afterdot - array[0]);
              for (let x = 0; x < array.length; x++) {
                if (Math.abs(afterdot - array[x]) < temp) {
                  temp = Math.abs(afterdot - array[x]);
                  y = x;
                }
              }
              afterdot = array[y];
            }
          }
          this.tableData[i].buyer_sale_price = beforedot + afterdot;
        }
        this.computeReady(this.tableData);
      }
      if (this.sheet_no) {
        this.modify_list = [];
        for (let i = 0; i < this.tableData.length; i++) {
          this.modify_list.push(this.tableData[i].rowKey);
        }
      }

      this.loadingInstance.close();
    },
    // 打开表格传输组件
    daoRu() {
      if (this.sheet_no && this.sheet_approve === "1") {
        this.warnMessage(
          "已经审核的单据不允许修改！如需修改请先进行反审核操作。"
        );
        return;
      }
      if (this.sheet_no || this.sheet_no.length > 0) {
        this.warnMessage("修改单据不支持导入");
        return;
      }
      /* if (this.sheet_no.length > 1 && this.sheet_no != "") {
        this.warnMessage("单据在修改状态！");
        return;
      } */
      this.$refs.excel.showModel();
    },
    //右键菜单点击事件
    contextmenuClick(e) {
      if (this.sheet_no && this.sheet_approve === "1") {
        this.warnMessage(
          "已经审核的单据不允许修改！如需修改请先进行反审核操作。"
        );
        return;
      }
      if (e === "DialogVisible" || e === "bulkModify") {
        this.checkModify(e);
      } else {
        this[e]();
      }
    },
    //导出表格
    exportXML() {
      // this.successMessage("导出暂时不能用");
      var data = [];
      for (var i = 0; i < this.tableData.length; i++) {
        var dataitem = {};
        for (var key in this.tableData[i]) {
          switch (key) {
            case "item_no":
              dataitem["货号"] = this.tableData[i][key];
              break;
            case "barcode":
              dataitem["商品条码"] = this.tableData[i][key];
              break;
            case "item_name":
              dataitem["商品名称"] = this.tableData[i][key];
              break;
            case "in_price":
              dataitem["进价"] = this.tableData[i][key];
              break;
            case "qty":
              dataitem["入库"] = this.tableData[i][key];
              break;
            case "sale_price":
              dataitem["售价（出库价）"] = this.tableData[i][key];
              break;
            case "class_no":
              dataitem["类别"] = this.tableData[i][key];
              break;

            case "production_day":
              dataitem["生产日期"] = this.tableData[i][key];
              break;
            /* case "sup_no":
              dataitem["供应商"] = this.tableData[i][key];
              break;
              case "sup_price":
              dataitem["供货价"] = this.tableData[i][key];
              break;
            case "buyer_qty":
              dataitem["购买方数量"] = this.tableData[i][key];
              break;
            case "buyer_price":
              dataitem["购买方进价"] = this.tableData[i][key];
              break;
            case "advise_price":
              dataitem["建议售价"] = this.tableData[i][key];
              break; */
            case "buyer_sale_price":
              dataitem["售价"] = this.tableData[i][key];
              break;
          }
        }
        data.push(dataitem);
      }
      exportExcel(
        data,
        this.file_name ? this.file_name : `${this.header_info.other_mch_no}.xls`
      );
    },
    /**
     * 插入商品
     */
    addGoods() {
      // this.maintableShow = true;
      // this.tableDataShow = false;
      /* for(let i=0;i<this.tableData.length;i++){

      } */
      if (this.sheet_no && this.sheet_approve === "1") {
        this.warnMessage(
          "已经审核的单据不允许修改！如需修改请先进行反审核操作。"
        );
        return;
      }
      let a = this.tableData.length + 1;
      if (this.sheetwho === "outsheet") {
        this.tableData.push({
          item_no: "",
          barcode: "",
          item_name: "",
          class_no: "",
          production_day: "",
          sale_price: 0,
          advise_price: 0,
          qty: 0,
          money: 0,
          rowKey: a,
          class_state: "0",
          modify_flag: "insert"
        });
      } else if (this.sheetwho === "insheet") {
        this.tableData.push({
          item_no: "",
          barcode: "",
          item_name: "",
          class_no: "",
          production_day: "",
          sup_price: "",
          sup_qty: "",
          advise_price: 0,
          in_price: 0,
          buyer_sale_price: 0,
          qty: 0,
          money: 0,
          rowKey: a,
          class_state: "0",
          modify_flag: "insert"
        });
      }

      // this.tableDataShow = true;
      // this.maintableShow = true;

      //选中新增行
      this.$nextTick(() => {
        this.$refs.maintableRef.setCellSelection({
          rowKey: a,
          colKey: "barcode"
        });
      });
    },
    /**
     * 删除商品
     * @param {*} key
     */
    deleteGoods(key) {
      if (this.sheet_no && this.sheet_approve === "1") {
        this.warnMessage(
          "已经审核的单据不允许修改！如需修改请先进行反审核操作。"
        );
        return;
      }
      // 如果是自建入库单 可以删除
      if (this.checkedGoods.length === 0) {
        this.$message("没有选中的商品");
        return;
      }

      for (let i = 0; i < this.tableData.length; i++) {
        for (let j = 0; j < this.checkedGoods.length; j++) {
          if (this.tableData[i].rowKey === this.checkedGoods[j]) {
            if (this.sheet_no && !key && this.tableData[i].barcode !== "") {
              this.tableData[i].modify_flag = "delete";
              this.tableData[i].class_state = "4";
              this.modify_list.push(this.tableData[i].rowKey);
            } else {
              this.tableData.splice(i, 1);
            }
          }
        }
      }
      this.checkedGoods = [];
      this.getSum();
      this.$message({
        type: "success",
        message: "操作成功!"
      });
      if (!this.sheet_no) {
        this.$nextTick(() => {
          this.setRowKey();
        });
      }
    },
    /**
     * 设置行号
     */
    setRowKey() {
      this.maintableShow = false;
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].rowKey = i + 1;
      }
      this.$nextTick(() => {
        this.maintableShow = true;
      });
    },
    // 计算
    // 页脚
    /**
     * 初始化页脚
     */
    initFooterData() {
      if (this.tableData.length === 0 || this.tableData == []) {
        this.footData = [];
        return;
      }
      // 入库出库不一样
      if (this.sheetwho === "outsheet") {
        this.footData = [
          {
            rowKey: "999999999",
            a: "",
            item_no: "",
            barcode: "合计",
            item_name: "",
            sup_price: "",
            /* buyer_qty: myFixed(this.header_info.total_buyer_qty, 2)
              ? myFixed(this.header_info.total_buyer_qty, 2)
              : 0, */
            advise_price: "",
            in_price: "",
            qty: myFixed(this.header_info.total_qty, 2)
              ? myFixed(this.header_info.total_qty, 2)
              : 0,
            money: myFixed(this.header_info.total_amount, 4)
              ? myFixed(this.header_info.total_amount, 4)
              : 0
          }
        ];
        // sup_qty: "",
      } else if (this.sheetwho === "insheet") {
        this.footData = [
          {
            rowKey: "999999999",
            a: "",
            item_no: "",
            barcode: "合计",
            item_name: "",
            class_no: "",
            production_day: "",
            sup_price: "",
            /* sup_qty: myFixed(this.header_info.total_sup_qty, 2)
              ? myFixed(this.header_info.total_sup_qty, 2)
              : 0, */
            advise_price: "",
            in_price: "",
            buyer_sale_price: "",
            profit: "",
            qty: myFixed(this.header_info.total_qty, 2)
              ? myFixed(this.header_info.total_qty, 2)
              : 0,
            money: myFixed(this.header_info.total_amount, 4)
              ? myFixed(this.header_info.total_amount, 4)
              : 0
          }
        ];
      }
    },
    /**
     * 计算合计值，设置底部合计区域数据
     */
    getSum() {
      // rawqty 可以改
      this.header_info.total_qty = 0;
      this.header_info.total_amount = 0;
      // this.header_info.total_sup_qty = 0;
      // this.header_info.total_buyer_qty = 0;
      if (this.tableData.length === 0) { //如果0条数据 则初始化合计
        this.initFooterData();
        return;
      }
      for (var j = 0; j < this.tableData.length; j++) {
        /* console.log(`第${j}个money ${this.tableData[j].money}`);
        console.log(`第${j}个qty ${this.tableData[j].qty} `,);
        console.log(`第${j}个sup_qty ${this.tableData[j].sup_qty}`);
        console.log(`第${j}个sup_price ${this.tableData[j].price} `); */
        this.header_info.total_amount += Number(this.tableData[j].money);
        this.header_info.total_qty += Number(this.tableData[j].qty);

        /* if (this.tableData[j].sup_qty) {
          this.header_info.total_sup_qty += Number(this.tableData[j].sup_qty);
        } */
        /* if (this.tableData[j].buyer_qty) {
          this.header_info.total_buyer_qty += Number(
            this.tableData[j].buyer_qty
          );
        } */
      }
      this.header_info.total_amount = myFixed(this.header_info.total_amount, 4);
      this.initFooterData();
    },
    /**
     * 进价数量 更改后计算金额
     */
    compute() {
      var that = this;
      if (this.sheetwho === "outsheet") {
        this.tableData.forEach(function (item, i, arr) {
          if (arr[i].barcode === that.row_data.barcode) {
            arr[i].money = that.myFixed(
              Number(that.tableData[i].sale_price) *
              Number(that.tableData[i].qty),
              4
            );
          }
        });
      } else if (this.sheetwho === "insheet") {
        this.tableData.forEach(function (item, i, arr) {
          // console.log("进价数量 更改后计算金额", item);
          if (arr[i].barcode === that.row_data.barcode) {
            arr[i].money = that.myFixed(
              Number(that.tableData[i].in_price) *
              Number(that.tableData[i].qty),
              4
            );
            arr[i].profit =
              arr[i].buyer_sale_price !== 0
                ? that.myFixed(
                  (1.0 - arr[i].in_price / arr[i].buyer_sale_price) * 100,
                  2
                ) + "%"
                : 0;
          }
        });
      }
    },
    /**
     * 金额更改后计算进价(出库单ok)
     */
    computeInPrice() {
      var that = this;
      if (this.sheetwho === "insheet") {
        this.tableData.forEach(function (item, i, arr) {
          if (arr[i].barcode === that.row_data.barcode) {
            arr[i].in_price =
              Number(that.tableData[i].money) / Number(that.tableData[i].qty);
            arr[i].profit =
              arr[i].buyer_sale_price !== 0
                ? that.myFixed(
                  (1.0 - arr[i].in_price / arr[i].buyer_sale_price) * 100,
                  2
                ) + "%"
                : 0;
          }
        });
      } else if (this.sheetwho === "outsheet") {
        this.tableData.forEach(function (item, i, arr) {
          if (arr[i].barcode === that.row_data.barcode) {
            arr[i].sale_price = that.myFixed(
              Number(that.tableData[i].money) / Number(that.tableData[i].qty),
              4
            );
          }
        });
      }
    },
    /**
     * 计算每行的金额
     */
    computeReady(data) {
      var that = this;
      if (this.sheetwho === "insheet") {
        data.forEach(function (item, i, arr) {
          if (item.money) {
            if (item.qty === 0) {
              return;
            }
            item.in_price =
              item.qty && item.qty !== 0
                ? myFixed(Number(item.money) / Number(item.qty), 4)
                : 0;
          } else {
            if (item.qty === 0) {
              return;
            }
            item.money =
              item.in_price && item.qty && item.qty !== 0 && item.in_price !== 0
                ? myFixed(Number(item.in_price) * Number(item.qty), 4)
                : 0;
          }
          item.profit =
            item.buyer_sale_price !== 0
              ? that.myFixed(
                (1.0 - item.in_price / item.buyer_sale_price) * 100,
                2
              ) + "%"
              : 0;
        });
      } else if (this.sheetwho === "outsheet") {
        data.forEach(function (item, i, arr) {
          if (item.money) {
            item.sale_price =
              item.qty && item.qty !== 0
                ? myFixed(Number(item.money) / Number(item.qty), 4)
                : 0;
          } else {
            item.money =
              item.sale_price &&
                item.qty &&
                item.qty !== 0 &&
                item.sale_price !== 0
                ? myFixed(Number(item.sale_price) * Number(item.qty), 4)
                : 0;
          }
          // item.money = parseInt(item.sale_price) * parseInt(item.qty);
        });
      }
    },

    /**
     * 删除条码为空的行
     */
    deleteemptyline() {
      for (let i = 0; i < this.tableData.length; i++) {
        if (
          !this.tableData[i].barcode ||
          this.tableData[i].barcode.length === 0
        ) {
          this.tableData.splice(i, 1);
        }
      }
    },
    /**
     * 更新并导入获取表格组件的返回值
     */
    async updateTableData(val) {
      // this.maintableShow = false;
      this.deleteemptyline();

      this.zero(val);
      if (this.sheet_no) {
        for (let i = 0; i < val.length; i++) {
          val[i].modify_flag = "insert";
        }
      }
      var array = [];
      for (var i = 0; i < val.length; i++) {
        var _index = this.tableData.findIndex(x => x.barcode === val[i].barcode);
        if (_index > -1) {
          val[i].moeny = 0;
          val[i].rowKey = this.tableData[_index].rowKey;
          if (this.sheetwho === "outsheet") {
            this.tableData[_index].qty = val[i].qty;
            this.tableData[_index].sale_price = val[i].sale_price;
            this.tableData[_index].production_day = val[i].production_day;
            this.tableData[_index].money = myFixed(
              Number(val[i].sale_price) * Number(val[i].qty),
              4
            );
            if (this.sheet_no !== "" && this.sheet_no.length > 1) {
              this.modify_list.push(this.tableData[_index].rowKey);
            }
          } else if (this.sheetwho === "insheet") {
            this.tableData[_index].qty = val[i].qty;
            this.tableData[_index].buyer_sale_price = val[i].sale_price
              ? val[i].sale_price
              : 0;
            this.tableData[_index].profit =
              val[i].buyer_sale_price !== 0
                ? this.myFixed(
                  (1.0 - val[i].in_price / val[i].buyer_sale_price) * 100,
                  2
                ) + "%"
                : 0;

            this.tableData[_index].production_day = val[i].production_day;
            this.tableData[_index].money = myFixed(
              Number(val[i].sale_price) * Number(val[i].qty),
              4
            );
            if (this.sheet_no !== "" && this.sheet_no.length > 1) {
              this.modify_list.push(this.tableData[_index].rowKey);
            }
          }
        } else {
          array.push(val[i]);
          this.modify_list.push(val[i].rowKey);
        }
      }
      this.insertData(array);

      // this.maintableShow = true;
      this.computeReady(this.tableData);
      this.getSum();
      this.loadingInstance.close();
    },
    /**
     * 覆盖并导入数据 导入数据
     */
    async CoverTableData(val) {
      this.loadingInstance.show();
      this.tableData = [];
      if (this.sheet_no) {
        for (let i = 0; i < val.length; i++) {
          val[i].modify_flag = "insert";
        }
      }
      this.insertData(val);
      this.zero(this.tableData);
      if (this.sheetwho === "insheet") {
        this.rawAssignment(this.tableData);
      }
      this.computeReady(this.tableData);
      this.getSum();
      this.$refs.excel.hiddleBox();
    },
    /**
     * 插入数据
     * @param {Array} vall 待插入的商品列表
     */
    async insertData(vall) {
      const that = this;
      setTimeout(() => {
        this.loadingInstance.show();
      });
      this.deleteemptyline();
      let arr1 = [];//需要插入的所有条码
      let val = [];//需要插入的详细信息
      this.morelist = [];
      //vall 所有需要插入的数据
      //生成两个数组一个是只有条码，另一个是所有信息 会排除重复值
      for (let i = 0; i < vall.length; i++) {
        if (vall[i].barcode && arr1.indexOf(vall[i].barcode) === -1) {
          arr1.push(vall[i].barcode);
          val.push(vall[i]);
        }
      }
      try {
        //赋值rowkey
        for (let j = 0; j < val.length; j++) {
          val[j].rowKey = j + this.tableData.length + 1;
          // val[j].item_name="";
        }
      } catch (e) {
        this.warnMessage(JSON.stringify(e));
      }
      // console.log("插入函数的数组：", val);
      var list = [];
      if (this.sheetwho === "outsheet") {
        this.loadingInstance.show();
        try {
          //
          for (let i = 0; i < val.length; i++) {
            list.push(val[i].barcode);
            let mdata = { // 购买的信息
              rowKey: val[i].flow_no ? val[i].flow_no : val[i].rowKey,
              barcode: val[i].barcode,
              advise_price: val[i].advise_price,
              sale_price: val[i].sale_price,
              qty: val[i].qty,
              money: val[i].amount
                ? val[i].amount
                : myFixed(Number(val[i].sale_price) * Number(val[i].qty), 4),
              production_day: val[i].production_day,
              buyer_qty: val[i].buyer_qty ? val[i].buyer_qty : 0,
              buyer_price: val[i].buyer_price ? val[i].buyer_price : 0,
              class_no: "",
              item_name: val[i].item_name ? val[i].item_name : "",
              class_state: "0",
              modify_flag: val[i].modify_flag ? val[i].modify_flag : "update"
            };
            this.tableData.push(mdata);
          }
          //搜索线上库 补齐基本信息
          const res = await basegoodsBatchquery(list);
          if (this.testR(res)) {
            var array2 = [];
            for (let i = 0; i < res.data.resp_data.length; i++) {
              for (let j = 0; j < this.tableData.length; j++) {
                if (
                  this.tableData[j].barcode === res.data.resp_data[i].barcode &&
                  res.data.resp_data[i].query_state === "SUCCESS"
                ) {
                  this.tableData[j].item_name = res.data.resp_data[i].item_name
                    ? res.data.resp_data[i].item_name
                    : this.tableData.item_name;
                  this.tableData[j].class_no = "";
                  this.tableData[j].advise_price = res.data.resp_data[i]
                    .advise_price
                    ? res.data.resp_data[i].advise_price
                    : 0;
                  // this.tableData[j].class_state = "0";
                  //库里有的商品放到array2数组里面
                  array2.push(this.tableData[j].barcode);
                  /* if (this.sheet_no != "" && this.sheet_no.length > 1) {
                  this.modify_list.push(this.tableData[j].rowKey);
                } */
                }
              }
            }
            //获取上次交易的价格
            let tpslist = [];
            if (this.header_info.other_mch_no && !this.sheet_no) {
              const tps = await sheetLastTranscationPrice(
                list,
                this.header_info.other_mch_no
              );
              if (this.testR(tps)) {
                tpslist = tps.data.resp_data.data;
              }
            }
            for (let j = 0; j < this.tableData.length; j++) {
              if (
                arr1.indexOf(this.tableData[j].barcode) > -1 &&
                array2.indexOf(this.tableData[j].barcode) === -1
              ) {
                this.tableData[j].class_state = "6";
              }
            }
            if (tpslist.length && tpslist.length > 0) {
              this.$confirm("是否将上次价格引入?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  for (let i = 0; i < this.tableData.length; i++) {
                    for (let j = 0; j < tpslist.length; j++) {
                      if (this.tableData[i].barcode === tpslist[j].barcode) {
                        // this.tableData[i].sale_price = tpslist[j].price;
                        this.tableData[i].sale_price = tpslist[j].price
                          ? tpslist[j].price
                          : this.tableData[i].sale_price;
                      }
                    }
                  }
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消"
                  });
                });
            }
          }
        } catch (e) {
          this.loadingInstance.close();
        }
        this.allGoods_list = [];
        this.allGoods_list = this.tableData;
        this.addGoods();
        this.loadingInstance.close();
      } else if (this.sheetwho === "insheet") {
        this.loadingInstance.show();
        try {
          for (let i = 0; i < val.length; i++) {
            list.push(val[i].barcode);
            //给每一行赋值初始值
            let mdata = {
              rowKey: val[i].flow_no ? val[i].flow_no : val[i].rowKey,
              barcode: val[i].barcode,
              in_price: val[i].in_price,
              qty: val[i].qty,
              buyer_sale_price: val[i].sale_price ? val[i].sale_price : 0,
              money: val[i].amount
                ? val[i].amount
                : myFixed(Number(val[i].in_price) * Number(val[i].qty), 4),
              profit:
                val[i].buyer_sale_price && val[i].buyer_sale_price != 0
                  ? that.myFixed(
                    (1.0 - val[i].in_price / val[i].buyer_sale_price) * 100,
                    2
                  ) + "%"
                  : 0,
              production_day: val[i].production_day,
              class_no: "",
              /* sup_price: val[i].sale_price ? val[i].sale_price : "0",
              sup_qty: val[i].sale_qty ? val[i].sale_qty : "0", */
              item_name: val[i].item_name ? val[i].item_name : "",
              class_state: "0",
              modify_flag: val[i].modify_flag ? val[i].modify_flag : "update"
            };
            /* if(val[i].item_no){
              mdata.item_no = val[i].item_no;
              mdata.item_name =val[i].item_name;
              mdata.class_no =val[i].class_no;
              this.tableData[j].stock = await offlineQueryStock(mdata.barcode,mdata.sup_no,this.header_info.branch_no)?await offlineQueryStock(mdata.barcode,mdata.sup_no,this.header_info.branch_no):"0.00";
              mdata.class_state = "0";
            } */
            this.tableData.push(mdata);
          }
          //线下没有的商品;
          var offnolist = [];
          var array2 = []; //能获取到信息的list 包括线上和线下
          //TODO: 需要先用arr2 赋值 有重复条码时再直接赋值

          const goodsbranchres = await offlineGoodsBatchQuery(list);
          if (
            this.testR(goodsbranchres) &&
            goodsbranchres.data.return_code === "SUCCESS" &&
            goodsbranchres.data.result_code === "SUCCESS" &&
            goodsbranchres.data.resp_data
          ) {
            const tgoodslist = goodsbranchres.data.resp_data;
            for (let i = 0; i < tgoodslist.length; i++) {
              //只有一个条码的时候
              if (tgoodslist[i][Object.keys(tgoodslist[i])[0]].length === 1) {
                for (let j = 0; j < this.tableData.length; j++) {
                  if (
                    this.tableData[j].barcode === Object.keys(tgoodslist[i])[0]
                  ) {
                    this.tableData[j].item_no =
                      tgoodslist[i][Object.keys(tgoodslist[i])[0]][0].item_no;
                    this.tableData[j].item_name = tgoodslist[i][
                      Object.keys(tgoodslist[i])[0]
                    ][0].item_name
                      ? tgoodslist[i][Object.keys(tgoodslist[i])[0]][0]
                        .item_name
                      : this.tableData[j].item_name;
                    this.tableData[j].class_no =
                      tgoodslist[i][Object.keys(tgoodslist[i])[0]][0].class_no;
                    this.tableData[j].stock =
                      tgoodslist[i][Object.keys(tgoodslist[i])[0]][0].number;
                    this.tableData[j].class_state = "0";
                    array2.push(this.tableData[j].barcode);
                  }
                }
              } else if (
                tgoodslist[i][Object.keys(tgoodslist[i])[0]].length > 1
              ) {
                this.morelist.push(
                  tgoodslist[i][Object.keys(tgoodslist[i])[0]]
                ); //将多个条码的选出来
                array2.push(Object.keys(tgoodslist[i])[0]); //这个也不用搜索线上库
                //TODO:
                // this.$refs.wtySelectBoxRef.showDialog(res.data.resp_data);
              }
            }
          }
          //offnolist 找出线下没有的商品条码
          for (let j = 0; j < this.tableData.length; j++) {
            if (
              arr1.indexOf(this.tableData[j].barcode) > -1 &&
              array2.indexOf(this.tableData[j].barcode) === -1 &&
              offnolist.indexOf(this.tableData[j].barcode) === -1
            ) {
              // console.log(this.tableData[j].barcode);
              offnolist.push(this.tableData[j].barcode);
            }
          }

          //单个搜索
          /* for (let i = 0; i < list.length; i++) {
            const res = await offlineSearchGoodsInfo(list[i]);
            // console.log("返回值：-----------",res);
            if (this.testR(res)) {
              if (res.data.resp_data.length == 0) {
                offnolist.push(list[i]);
                //TODO: 尝试
                this.tableData[i].class_state = "5";
              } else if (res.data.resp_data.length == 1) {
                console.log("11111111111111111111111111111111111");
                this.tableData[i].item_name = res.data.resp_data[0].item_name;
                this.tableData[i].class_no = res.data.resp_data[0].class_no;
                this.tableData[i].class_state = "0";
                array2.push(this.tableData[i].barcode);
              } else if (res.data.resp_data.length > 1) {
                //TODO: 弹出选择框
                console.log("搜到到多个条码！！！");
              }
            }
          } */
          //本地没有的搜索商品库将信息补全
          const res = await basegoodsBatchquery(offnolist);
          if (this.testR(res)) {
            for (let i = 0; i < res.data.resp_data.length; i++) {
              for (let j = 0; j < this.tableData.length; j++) {
                if (
                  this.tableData[j].barcode === res.data.resp_data[i].barcode &&
                  res.data.resp_data[i].query_state === "SUCCESS"
                ) {
                  this.tableData[j].item_name = this.tableData[j].item_name
                    ? this.tableData[j].item_name
                    : res.data.resp_data[i].item_name;
                  this.tableData[j].class_no = this.tableData[j].class_no
                    ? this.tableData[j].class_no
                    : "";
                  this.tableData[j].advise_price = res.data.resp_data[i]
                    .advise_price
                    ? res.data.resp_data[i].advise_price
                    : 0;
                  this.tableData[j].class_state = "6";
                  array2.push(this.tableData[j].barcode);
                  /* if (this.sheet_no != "" && this.sheet_no.length > 1) {
                  this.modify_list.push(this.tableData[j].rowKey);
                } */
                }
              }
            }
          }
          //调用接口引入上次进价
          var tpslist = [];
          if (this.header_info.other_mch_no && !this.sheet_no) {
            const tps = await sheetLastTranscationPrice(
              list,
              this.header_info.other_mch_no
            );
            if (this.testR(tps)) {
              tpslist = tps.data.resp_data.data;
            }
            // console.log("上一次的售价：", tps);
          }
          //把库里没有的行修改样式
          //arr1 所有条码
          //array2 线下线上都没有的
          for (let j = 0; j < this.tableData.length; j++) {
            if (
              arr1.indexOf(this.tableData[j].barcode) > -1 &&
              array2.indexOf(this.tableData[j].barcode) === -1
            ) {
              // console.log(this.tableData[j].barcode);
              this.tableData[j].class_state = "6";
            }
          }
          if (tpslist.length && tpslist.length > 0) {
            this.$confirm("是否将上次价格引入", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消"
            })
              .then(() => {
                for (let i = 0; i < this.tableData.length; i++) {
                  for (let j = 0; j < tpslist.length; j++) {
                    if (this.tableData[i].barcode === tpslist[j].barcode) {
                      this.tableData[i].in_price = tpslist[j].price
                        ? tpslist[j].price
                        : this.tableData[i].in_price;
                    }
                  }
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消"
                });
              });
          }
        } catch (e) {
          console.log("错误---------", e);
          this.loadingInstance.close();
        }

        this.allGoods_list = [];
        this.allGoods_list = this.tableData;
        this.addGoods();
        this.loadingInstance.close();
        this.showRadioDialog(); //挨个显示重复条码
      }
    },
    /**
     * 当有多个商品返回时选择的某个商品
     * @param {*} res单选商品返回值
     */
    getRadioReturn(res) {
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].barcode === res.barcode) {
          this.$set(this.tableData[i], "item_no", res.item_no);
          this.$set(this.tableData[i], "item_name", res.item_name);
          this.$set(this.tableData[i], "class_state", "0");
          this.$set(this.tableData[i], "class_no", res.class_no);
          this.$set(this.tableData[i], "stock", res.number);
        }
      }
      var list = [];
      if (this.morelist.length > 1) {
        for (let i = 1; i < this.morelist.length; i++) {
          list.push(this.morelist[i]);
        }
        this.morelist = list;
        this.showRadioDialog();
      }
    },
    showRadioDialog() {
      if (this.morelist.length > 0) {
        this.$refs.wtyRadioSelectBoxRef.showDialog(
          this.morelist[0],
          "库中有重复条码请选择正确商品"
        );
      }
    },

    /**
     * 赋值原始数据（原始进价、原始售价）
     * @param list 
     */
    rawAssignment(list) {
      list.forEach(item => {
        // item.raw_in_price = item.in_price;
        // item.sup_qty = item.qty;
      });
    },
    //TODO:获取线下进价卖价
    /**
     * 把非法的进价、售价、数量、金额、赋值为 0
     * @param{Array} data 需要格式化的列 一般传tableData
     */
    zero(data) {
      var that = this;
      /* eslint-disable */
      if (data.length === 0) {
        return;
      }
      data.forEach(function (item, i, arr) {
        if (that.sheetwho === "outsheet") {
          if (
            !item.sale_price ||
            item.sale_price === "" ||
            item.sale_price.length === 0 ||
            /^[\-]{0,1}([1-9]\d{0,6}|0)(\.\d{1,4})?$/.test(item.sale_price) ===
            false ||
            /[^\-0-9\.]/g.test(item.sale_price) === true
          ) {
            arr[i].sale_price = 0;
          }
        }
        if (that.sheetwho === "insheet") {
          if (
            !item.in_price ||
            item.in_price === "" ||
            item.in_price.length === 0 ||
            /^[\-]{0,1}([1-9]\d{0,6}|0)(\.\d{1,4})?$/.test(item.in_price) ===
            false ||
            /[^\-0-9\.]/g.test(item.in_price) === true
          ) {
            arr[i].in_price = 0;
          }
        }

        if (
          !item.qty ||
          item.qty === "" ||
          item.qty.length === 0 ||
          /^[\-]{0,1}([1-9]\d{0,6}|0)(\.\d{1,4})?$/.test(item.qty) === false ||
          /[^\-0-9\.]/g.test(item.qty) === true
        ) {
          arr[i].qty = 0;
        }
        if (
          !item.money ||
          item.money === "" ||
          item.money.length === 0 ||
          /^[\-]{0,1}([1-9]\d{0,6}|0)(\.\d{1,4})?$/.test(item.money) === false ||
          /[^\-0-9\.]/g.test(item.money) === true
        ) {
          arr[i].money = 0;
        }
      });
    }
  }
};
</script>
<style lang="less">
.p-label {
  display: inline-block;
  // background-color: rgb(255, 94, 94);
  width: 85px;
  // height: 28px;
  margin: 0;
  padding: 0;
}

/* .table-body-cell-class1 {
  background: #91d5ff !important;
  color: #fff !important;
} */

.el-col {
  height: 30px !important;
  padding: 0;
  margin: 0;
}

.table-body-cell-goods-even {
  background: #f8f8f8 !important;
}

.table-body-cell-goods-delete {
  background: #b5b5b5 !important;
  color: #fff !important;
}

.span-inline {
  i {
    width: auto;
    font-style: normal;
  }

  display: flex;
  align-items: center;
  min-width: 300px;
}

#contextmenu-target {
  width: auto;
  height: auto;
}

.thead {
  width: 100%;
  height: 25px;
  background-color: rgb(230, 230, 230);
}

.top-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  height: 40px;

  .top-btn-danju {
    display: flex;
    justify-content: left;
    align-items: center;
    height: auto;
    width: calc(100% - 540px);
    // border-left: 5px solid #ffbb72;
  }
}

.fa {
  width: 100%;
  height: 100%;
  // background-color: rgb(251, 112, 112);
}

#in-sheet {
  width: 100%;
  height: 96%;
  // border: thick double #dcdfe6;
  padding: 0 10px 10px 10px;
  border: 1px double #dcdfe6;
  border-radius: 5px;
  height: auto !important;
  //margin-bottom: 10px;
}

.danju {
  height: 60px;
  line-height: 3;
  // background-color: rgba(4, 138, 247, 0.418);
  text-align: center;
  font-size: 20px;
}

.danju-sheetno {
  position: relative;
  width: 100%;
  text-align: center;
  font-weight: 700;
  text-shadow: 2px 2px 3px #8f8f8f;
  display: flex;
  justify-content: center;
  align-items: center;

  .watermark {
    width: 100px;
    height: 80px;
    position: absolute;
    top: 10px;
    left: 0px;
    z-index: 9;
  }
}

.danju-basic {
  // height: 30px;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  text-shadow: 2px 2px 3px #8f8f8f;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding: 10px 0;
}

/* .danju-insheet {
  // background-color: rgba(4, 36, 247, 0.3);
}
.danju-outsheet {
  // background-color: rgba(247, 85, 4, 0.3);
}
 */
.el-card {
  margin: 10px 10px 0 10px;
}

.el-col {
  height: 40px;
  line-height: 2;
}

.el-input-tit {
  border: 0 !important;
}

/* .danju >>> .el-input-tit {
  border: 0;
} */
.biaotou-remark {
  width: 100%;
  border: none;
  outline: none;
  border-bottom: 1px solid rgb(133, 131, 131);
}

.block {
  display: inline-block;
}

.el-row-2 {
  margin-top: 5px;
  font-weight: 700;
}

.el-row-1 {
  // margin-top: 10px;
  font-weight: 700;
}

/*.demo-drawer__footer {
  width: 100%;
  position: absolute;
  bottom: 10px;
  left: 60px;
}
 .demo-drawer__footer >>> .el-button {
  display: inline-block;
  width: 40%;
}
.footer-btn {
  display: inline-block;
  width: 40%;
  margin-left: 40px;
}*/
.el-input-select {
  width: 130px;
}

.tableEmpty {
  height: 350px;
  border: 2px solid #efefef;
  line-height: 20;
  text-align: center;
}

/*.upload-box {
  position: relative;
  top: 20px;
  left: 20px;
}
.el-upload-list {
  width: 100px;
}
 .drawer-head-div {
  height: 40px;
  width: 100%;
  text-align: center;
  line-height: 2;
}
.drawer-head-div > i {
  display: inline-block;
  text-align: center;
  width: 45%;
  cursor: pointer;
} */

.el-table .disabledCheck .cell .el-checkbox__inner {
  display: none !important;
}
</style>
